import React from "react";
import {Autocomplete, TextField, Box, alpha} from "@mui/material";


export default function SucursalesAutocomplete({
    sucursales,
    sucEmiteFactura,
    setSucEmiteFactura,
}) {
  return (
    <Autocomplete
      size="small"
      disableClearable
      placeholder="Sucursal Factura"
      options={sucursales}
      value={sucEmiteFactura}
      onChange={(e, value) => {
        setSucEmiteFactura(value);
      }}
      noOptionsText={"No encontrado."}
      getOptionLabel={(option) => {
        return option?.nombre;
      }}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderOption={(props, option) => {
        return (
          <Box
            component="li"
            {...props}
            key={option.id}
            sx={{
              padding: "12px 16px !important",
              borderBottom: "1px solid #f1f5f9",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#f1f5f9 !important",
              },
              '&[aria-selected="true"]': {
                backgroundColor: alpha("#164e63", 0.08) + " !important",
                color: "#164e63",
                fontWeight: 600,
              },
            }}
          >
            {option?.nombre?.trim()}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Buscar sucursal..."
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#ffffff",
              transition: "all 0.3s ease",
              "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#164e63",
                },
              },
              "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#164e63",
                  borderWidth: "2px",
                },
              },
            },
            "& .MuiInputLabel-root": {
              color: "#475569",
              fontWeight: 500,
              "&.Mui-focused": {
                color: "#164e63",
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}
